/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  async listExpenseAccounts() {
    let data = { source: "Web" };
    let response = await apiCall("expense/accounts/list", data);
    return response;
  },

  async listPaymentAccounts() {
    let data = { source: "Web" };
    let response = await apiCall("expense/payment-accounts/list", data);
    return response;
  },

  async addExpense(
    paymentAccount,
    targetAccount,
    amount,
    transactionDate,
    description,
    payee,
    transactionRef,
    tag
  ) {
    let data = {
      trail_account: paymentAccount,
      target_account: targetAccount,
      amount: amount,
      transaction_date: transactionDate,
      description: description,
      payee: payee,
      transaction_reference: transactionRef,
      tag: tag,
    };
    let response = await apiCall("expense/add", data);
    return response;
  },

  async getExpenseBalance() {
    let data = { source: "Web" };
    let response = await apiCall("expense/balance", data);
    return response;
  },

  async listExpenseBalances() {
    let data = { source: "Web" };
    let response = await apiCall("expense/balances/list", data);
    return response;
  },

  async fetchInvoiceRecords(data) {
    let response = await apiCall("expense/invoicing/list", data);
    return response;
  },

  async createInvoice(data) {
    let response = await apiCall("expense/invoicing/create", data);
    return response;
  },

  async PayInvoice(data) {
    let response = await apiCall("expense/invoicing/pay", data);
    return response;
  },

  async fetchOutstandingInvoiceCount(data) {
    let response = await apiCall("transaction/expense/creditorledger/count_outstanding", data);
    return response;
  },

  async fetchOutstandingInvoices() {
    let response = await apiCall("transaction/expense/invoicing/list_outstanding_invoices", []);
    return response;
  },

  
};
